// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Lyk5h","darkText":"Footer_darkText__GGGSZ"};